import React, {useState, useEffect} from 'react';
import {Grid} from '@material-ui/core/';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import { useHistory } from "react-router-dom";
import Form from 'components/Form/FormTwoColumns';
import Table from 'components/Table';
import BotonPersonalizado from 'components/BotonNormal'
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
import { showMessagePersonalizedPosition, showMessagePersonalizedToast } from 'services/SweetAlert';
import { Search } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import DialogLoadingMessage from 'components/LoadingMessage/index'

function Homonimos(props) {
    const classes = useStyles(),
        [controller] = useState("verificarHomonimos"),
        [loading, setLoading] = useState(false),
        [header, setHeader] = useState([
            { title: 'Código de Referencia', field: 'id', cellStyle: { maxWidth: '80px' } },
            { title: 'Nombre Completo', field: 'nombres', cellStyle: { maxWidth: '100px' } },
            { title: 'Número boleta', field: 'datosPadron.nroBoleta', cellStyle: { maxWidth: '100px' } },
            { title: 'Estado Padrón', field: 'datosPadron.estadoPadron.nombreStatus', 
                render: rowData => <div>
                    {
                        ((rowData.datosPadron.estadoPadron.codStatus)  ? (rowData.datosPadron.estadoPadron.codStatus +'. ' ) : '') +
                        ((rowData.datosPadron.estadoPadron.nombreStatus)  ? (rowData.datosPadron.estadoPadron.nombreStatus) : '')
                    }
                </div>
            },
            { title: 'CUI del DPI', field: 'datosPadron.dpi.cui', cellStyle: { maxWidth: '100px' } },
            { title: 'Género', field: 'genero' },
            { title: 'Cédula', field: 'cedula' },
            { title: 'Departamento Cédula', field: 'departamentoCedula.nombre' },
            { title: 'Municipio Cédula', field: 'municipioCedula.name' },
            { title: 'Fecha Nacimiento', field: 'fechaNacimiento', render: (rowData) => functions.splitDate(rowData.fechaNacimiento) },
            { title: 'Departamento Nacimiento', field: 'departamentoNacimiento.nombre' },
            { title: 'Municipio Nacimiento', field: 'municipioNacimiento.name' },
            // {
            //     title: 'Acción', field: 'accion',
            //     render: rowData => <div>
            //         {
            //             <ButtonGroup color="primary" aria-label="outlined primary button group">
            //                 {/* <BotonElement icon={<Done />} title="Seleccionar ciudadano" /> */}
            //                 <BotonElement icon={<Done />} title="Seleccionar ciudadano" function={() => seleccionarCiudadano(rowData)} />
            //             </ButtonGroup>
            //         }
            //     </div>
            // },
        ]),
        [loadingMessage, setLoadingMessage] = useState({loading:false, title:''}),        
        [checkAutorization, setCheckAutorization] = useState(false);
    let filtros = {
        nom1: '', nom2: '', ape1: '', ape2: '',
        cedula: '', genero: '', fechaNacio: '', departamentoNacio: '0', municipioNacio: '0',
    };

    const validarErrorCUI = (event) => {
        if(!event.target.value) elements.cui.isError = false;
    }
    const [elements,setElements] = useState({
        titleHomonimos:{
            idelement: "titleHomonimos",title:'Filtros de Homónimos', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
        },    
            cui: {
                idelement: "cui",  value:'', label: "CUI del DPI", pattern:"^[0-9]{13}$", handler: validarErrorCUI,
                validators: ['requireds'], errorMessages:['Ingrese CUI del DPI, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },            
            primerNombre: {
                idelement: "primerNombre",  value:'', label: "Primer nombre", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese primer nombre, sin espacios al inicio y final'], isError:false, elementType:'input',
            },            
            segundoNombre: {
                idelement: "segundoNombre",  value:'', label: "Segundo Nombre", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese segundo nombre, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },            
            primerApellido: {
                idelement: "primerApellido",  value:'', label: "Primer Apellido", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese primer apellido, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },            
            segundoApellido: {
                idelement: "segundoApellido",  value:'', label: "Segundo Apellido", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese segundo apellido, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },            
            ordenCedula: {
                idelement: "ordenCedula",  value:'', label: "Orden de Cédula", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese orden de cédula, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
            registroCedula: {
                idelement: "registroCedula",  value:'', label: "Registro de Cédula", pattern:"^([\\w_Ññ][\\w_ Ññ]*[\\w_Ññ]){0,25}$", 
                validators: ['requireds'], errorMessages:['Ingrese registro de cédula, sin espacios al inicio y final'], isError:false, elementType:'input', showInputControl: true,
            },
    });
    const buscarInformacion = async () => {
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement(
            elements,
            setElements
        );        
        if(allGood){
            if (elements.cui.value || (elements.primerNombre.value && elements.primerApellido.value) || (elements.ordenCedula.value && elements.registroCedula.value)) {                
                setLoadingMessage({loading: true, title: 'Buscando homónimos'})
                setCheckAutorization(false);
                filtros.fechaNacio = ""
                filtros.departamentoNacio = "0"
                filtros.municipioNacio = "0"
                filtros.nom1 =    elements.primerNombre.value ? elements.primerNombre.value : ""
                filtros.nom2 =    elements.segundoNombre.value ? elements.segundoNombre.value : ""
                filtros.ape1 =    elements.primerApellido.value ? elements.primerApellido.value : ""
                filtros.ape2 =    elements.segundoApellido.value ? elements.segundoApellido.value : ""
                filtros.cui = elements.cui.value ? elements.cui.value : ''
                filtros.ordenCedula = elements.ordenCedula.value ? elements.ordenCedula.value:''
                filtros.registroCedula = elements.registroCedula.value ? elements.registroCedula.value:''
    
                try {
                    const hasPermission = await ApiServices.userSecurity.hasPermission('verificarHomonimos','list');    
                    if (hasPermission.error) {
                        setCheckAutorization(false);
                        showMessagePersonalizedToast('error', '¡Oops! ' +hasPermission.error.message)
                        return;
                    }
                   ApiServices[controller].initSearchCriteria.clear();
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("municipioNacio", filtros.municipioNacio);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("departamentoNacio", filtros.departamentoNacio);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("fechaNacio", filtros.fechaNacio);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("nom1", filtros.nom1);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("nom2", filtros.nom2);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("ape1", filtros.ape1);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("ape2", filtros.ape2);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("cui", filtros.cui);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("ordenCedula", filtros.ordenCedula);  
                   ApiServices[controller].initSearchCriteria.setOperator("and");
                   ApiServices[controller].initSearchCriteria.addEquals("registroCedula", filtros.registroCedula);                   
                   setCheckAutorization(true);
                   setLoadingMessage({loading: false, title: ''})
                } catch (error) {
                    if (error.status === 404) {
                        showMessagePersonalizedToast('error', '¡Oops! ' +'Oops!. Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                    } else {
                        showMessagePersonalizedToast('error', '¡Oops! ' +'Oops!. Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.')
                    }
                }
            } else {
                showMessagePersonalizedPosition('error', '¡Oops! ' ,'Tiene que filtrar como minimo CUI, Primer Nombre y Primer Apellido o Cédula.')
            }
            setLoadingMessage({loading: false, title: ''})
        }
    }
    
    const seleccionarCiudadano = (data) => {
        props.setIsSelectHomonimos(false)
        props.setDatosHomonimos({
            nroboleta: data.datosPadron?.nroBoleta ? data.datosPadron?.nroBoleta:'',
            cui: data.datosPadron?.dpi?.cui ? data.datosPadron?.dpi?.cui:'',
            nroorden: data.datosPadron?.dpi?.ordenCedulaRef ? data.datosPadron?.dpi?.ordenCedulaRef:'',
            nroregistro: data.datosPadron?.dpi?.registroCedulaRef ? data.datosPadron?.dpi?.registroCedulaRef:'',
            estado: data.datosPadron?.estadoPadron?.codStatus ? data.datosPadron?.estadoPadron?.codStatus:'',
            fechanacimiento: data.datosPadron?.fechaNacimiento ? data.datosPadron?.fechaNacimiento:new Date(),
            fechadefuncion: '',
            apellido1fallecido: data.datosPadron?.primerApellido ? data.datosPadron?.primerApellido:'',
            apellido2fallecido: data.datosPadron?.segundoApellido ? data.datosPadron?.segundoApellido:'',
            apellido3fallecido: data.datosPadron?.tercerApellido ? data.datosPadron?.tercerApellido.trim():'',
            nombre1fallecido: data.datosPadron?.primerNombre ? data.datosPadron?.primerNombre:'',
            nombre2fallecido: data.datosPadron?.segundoNombre ? data.datosPadron?.segundoNombre:'',
            apellido1padre: data.datosPadron?.complemento?.primerApellidoPadre ? data.datosPadron?.complemento?.primerApellidoPadre:'',
            apellido2padre: data.datosPadron?.complemento?.segundoApellidoPadre ? data.datosPadron?.complemento?.segundoApellidoPadre:'',
            nombrepadre: ((data.datosPadron?.complemento?.primerNombrePadre) ? (data.datosPadron?.complemento?.primerNombrePadre):'')+ ((data.datosPadron?.complemento?.segundoNombrePadre) ? (' '+data.datosPadron?.complemento?.segundoNombrePadre):''),
            apellido1madre: data.datosPadron?.complemento?.primerApellidoMadre ? data.datosPadron?.complemento?.primerApellidoMadre :'',
            apellido2madre: data.datosPadron?.complemento?.segundoApellidoMadre ? data.datosPadron?.complemento?.segundoApellidoMadre:'',
            nombremadre: ((data.datosPadron?.complemento?.primerNombreMadre) ? data.datosPadron?.complemento?.primerNombreMadre:'')+((data.datosPadron?.complemento?.segundoNombreMadre) ? (' '+data.datosPadron?.complemento?.segundoNombreMadre):''),
        })
        showMessagePersonalizedPosition('success','BIEN!', 'Homónimo seleccionado correctamente','center')
        props.setIsSelectHomonimos(true)
    }

    useEffect(() => {
        if(props.open){
            setCheckAutorization(false);
            filtros = {
                nom1: '', nom2: '', ape1: '', ape2: '',
                cedula: '', genero: '', fechaNacio: '', departamentoNacio: '0', municipioNacio: '0',
            };            
            functions.clearElementValues(elements, setElements);
        }
    }, [props.open])

    return (
        <div className={classes.root}>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <Grid container className={classes.colorComponente}>
                <Grid className={classes.AlignTable} item xs={12}>
                    <Form   elements= {elements}
                    />
                </Grid>
                <Grid item xs={12} className={classes.buttons}>
                    <BotonPersonalizado title={"Buscar"} botonPersonalizado={true} function={buscarInformacion} icon={<Search />} loading={loading} disabled={loading} />
                </Grid>                
                <Grid className={classes.AlignTable} item xs={12}>
                    {
                        (checkAutorization ) ?  
                        (
                            <Table
                                service={ApiServices[controller]}
                                title={"Listado de Homónimos"}
                                header={header}
                                showFilter={false}
                                showFilterGeneral={false}
                                selection={true}
                                onSelectionChange={()=>{}}
                                pageSize={5}
                            />
                        ): <Alert className={classes.marginAlert} variant="outlined" severity="warning">Si desea buscar Homónimos, de clic en el botón "BUSCAR"</Alert>
                    }
                </Grid>
                <div className={classes.lineaDegradadaBottom}></div>
            </Grid><br/>
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(Homonimos);